import React from 'react';
import { Card } from '../ui/Card';
import { PhoneIcon, MailIcon, CalendarIcon, PlusIcon, MessageSquareIcon } from 'lucide-react';
export function CommunicationTab({
  contact
}) {
  const formatDate = dateString => {
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit'
    }).format(date);
  };
  const getCommunicationIcon = type => {
    switch (type) {
      case 'call':
        return <PhoneIcon className="w-4 h-4 text-blue-500" data-id="element-260" />;
      case 'email':
        return <MailIcon className="w-4 h-4 text-green-500" data-id="element-261" />;
      case 'meeting':
        return <CalendarIcon className="w-4 h-4 text-purple-500" data-id="element-262" />;
      default:
        return <MessageSquareIcon className="w-4 h-4 text-gray-500" data-id="element-263" />;
    }
  };
  return <div data-id="element-264">
      <div className="flex justify-between items-center mb-4" data-id="element-265">
        <h2 className="text-lg font-medium text-gray-800" data-id="element-266">
          Communication History
        </h2>
        <div className="flex gap-2" data-id="element-267">
          <button className="flex items-center gap-1 px-3 py-1.5 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors text-sm" data-id="element-268">
            <PhoneIcon className="w-4 h-4" data-id="element-269" />
            <span data-id="element-270">Log Call</span>
          </button>
          <button className="flex items-center gap-1 px-3 py-1.5 bg-green-600 text-white rounded-md hover:bg-green-700 transition-colors text-sm" data-id="element-271">
            <MailIcon className="w-4 h-4" data-id="element-272" />
            <span data-id="element-273">Send Email</span>
          </button>
          <button className="flex items-center gap-1 px-3 py-1.5 bg-gray-200 text-gray-800 rounded-md hover:bg-gray-300 transition-colors text-sm" data-id="element-274">
            <PlusIcon className="w-4 h-4" data-id="element-275" />
            <span data-id="element-276">More</span>
          </button>
        </div>
      </div>
      <div className="space-y-4" data-id="element-277">
        {contact.communications.map(comm => <Card key={comm.id} title={<div className="flex items-center gap-2" data-id="element-279">
                {getCommunicationIcon(comm.type)}
                <span className="capitalize" data-id="element-280">{comm.type}</span>
                <span className="text-xs text-gray-500" data-id="element-281">
                  • {formatDate(comm.date)}
                </span>
              </div>} data-id="element-278">
            <div data-id="element-282">
              {comm.type === 'email' && comm.subject && <div className="mb-2" data-id="element-283">
                  <h4 className="text-sm font-medium text-gray-500" data-id="element-284">Subject</h4>
                  <p className="text-gray-800" data-id="element-285">{comm.subject}</p>
                </div>}
              {comm.duration && <div className="mb-2" data-id="element-286">
                  <h4 className="text-sm font-medium text-gray-500" data-id="element-287">
                    Duration
                  </h4>
                  <p className="text-gray-800" data-id="element-288">{comm.duration}</p>
                </div>}
              <div data-id="element-289">
                <h4 className="text-sm font-medium text-gray-500" data-id="element-290">Summary</h4>
                <p className="text-gray-800" data-id="element-291">{comm.summary}</p>
              </div>
            </div>
          </Card>)}
      </div>
    </div>;
}